<template>
    <Settings v-bind:title="'Add Courses'"> 
      <template ></template>
      <template v-slot:settings-aside-content>
        <form>
          <div class="row">
            <div class="col-lg-12 col-xl-12">            
              <v-text-field label="Academic Year" outlined dense></v-text-field>
              <v-checkbox label="Status (Active/Inactive)"></v-checkbox>
            </div>
          </div>
          <hr />
          <v-btn color="primary" type="submit">Submit</v-btn>
        </form>
      </template>
      <template v-slot:settings-content>
        <div class="row">
          <div class="col-lg-12 col-xl-12">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              dense
              outlined
            ></v-text-field>
            <v-data-table
              :headers="headers"
              :items="desserts"
              :search="search"
            ></v-data-table>
          </div>
        </div>
      </template>
    </Settings>

</template>

<script>
import Settings from "@/view/content/settings/Settings.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  components: {
    Settings,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "Academic", route: "academic" },
    ]);
  },
  computed: {},
};
</script>
